export default __webpack_public_path__ + "static/media/bigtime-shadow_mobile.05769676.svg";